import { UniversalProvider as Provider } from "./UniversalProvider.js";
export * from "./types/index.js";
export const UniversalProvider = Provider;
export default Provider;
